import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home-wrapper/index/user/Pro.png';
const _withScopeId = n => (_pushScopeId("data-v-7467aa65"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "template-swipe-pic",
  ref: "showRef ? 'swipePicRef' : ''"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "template-swipe-pro",
  alt: "pro"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TransitionImage = _resolveComponent("TransitionImage");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["template-swipe-item", {
      'template-swipe-item-m': $props.isMobile
    }])
  }, [_createElementVNode("div", _hoisted_1, [$props.swipeItem.isPro ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _createVNode(_component_TransitionImage, {
    "pic-obj": $options.picObj,
    "is-mobile": $props.isMobile,
    "frame-height": $data.frameStyle.height
  }, null, 8, ["pic-obj", "is-mobile", "frame-height"])], 512), _createElementVNode("div", {
    class: "template-swipe-btn wrap",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.applyTemplate && $options.applyTemplate(...args))
  }, _toDisplayString(_ctx.$t("template_inspo_apply")), 1)], 2);
}